import React from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
//components
import Input from "../../../../components/input/Input";
//services
import { onSubmitBlock } from "../../../../services/Register/onSubmitBlock";
//context
import { useAppContext } from "../../../../context/AppContext";

export const PanelCreateBlock = ({
  loading,
  setLoading,
  id,
  refetch,
  refresh,
}) => {
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const form = useForm();
  const errors = form.formState.errors;
  const sendBlock = async (data) => {
    const notification = toast.loading("Por favor aguarde...");
    setLoading(true);
    // setVisible(false);;
    try {
      await onSubmitBlock(id, data);
      form.reset();
      form.setValue("name", "");
      setLoading(false);
      toast.update(notification, {
        render: `${nomenclature[0].value} Cadastrada com sucesso!`,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      form.reset();
      setLoading(false);
      toast.update(notification, {
        render: `Falha ao cadastrar ${nomenclature[0].value}!`,
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
    refetch();
    refresh();
    // setVisible(true);
  };
  return (
    <>
      <Divider align="left">
        <div className="inline-flex align-items-center">
          <i className="pi pi-plus-circle mr-2"></i>
          <b> Cadastrar {nomenclature[0].value}</b>
        </div>
      </Divider>

      <div className="px-3">
        <form onSubmit={form.handleSubmit(sendBlock)}>
          <div className="row">
            <div className="col-md-12">
              <Input
                id="blockName"
                name="name"
                control={form.control}
                errors={errors}
                label="Sigla*"
                maxLength={20}
              />
            </div>
            <div className="pt-5 text-center">
              <Button
                rounded
                type="submit"
                label="Cadastrar"
                icon="fa fa-plus"
                loading={loading}
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
